// extracted by mini-css-extract-plugin
export default {"container":"PrioritySlider_container__48yvG"};